import { render, staticRenderFns } from "./BeVenueServices.vue?vue&type=template&id=3af9abb4&scoped=true"
import script from "./BeVenueServices.vue?vue&type=script&lang=js"
export * from "./BeVenueServices.vue?vue&type=script&lang=js"
import style0 from "./BeVenueServices.vue?vue&type=style&index=0&id=3af9abb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9abb4",
  null
  
)

export default component.exports